import { render, staticRenderFns } from "./UserRating.vue?vue&type=template&id=ddc5365c&"
import script from "./UserRating.vue?vue&type=script&lang=js&"
export * from "./UserRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports